var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoliditySeeklogocom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "398px",
    viewBox: "0 0 256 398",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Solidity") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("polyline", {
    opacity: 0.45,
    points: "191.513435 -1.38880392e-14 127.645979 113.512499 -2.77760784e-14 113.512499 63.8234781 -4.73316543e-30 191.513435 -4.73316543e-30"
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.6,
    points: "127.645979 113.512499 255.336913 113.512499 191.513435 -1.38880392e-14 63.8234781 -1.38880392e-14"
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.8,
    points: "63.8234781 226.981021 127.645979 113.512499 63.8234781 -1.38880392e-14 0 113.512499"
  }), /*#__PURE__*/React.createElement("polyline", {
    opacity: 0.45,
    points: "64.4416102 397.24977 128.309066 283.736782 256 283.736782 192.132055 397.24977 64.4416102 397.24977"
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.6,
    points: "128.308577 283.737271 0.618132052 283.737271 64.4411215 397.250259 192.131567 397.250259"
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.8,
    points: "192.132055 170.268749 128.308577 283.737271 192.132055 397.250259 255.999511 283.737271"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoliditySeeklogocom);
export default __webpack_public_path__ + "static/media/solidity-seeklogo.com.672a5aa17e624f5cde3387f1ed4d4ca6.svg";
export { ForwardRef as ReactComponent };